import styled from 'styled-components';
import { StyledDiv } from '../../../Theme/CommonStyled';

export const StyledIconContainer = styled(StyledDiv)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  width: 72px;
  height: 72px;
  border-radius: ${({ theme }): string => theme.radii.xl};
`;

export const StyledTimeContainer = styled(StyledDiv)`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 12px 16px;
  border-radius: ${({ theme }): string => theme.radii.xl};
`;
